/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {defaultMsalAngularConfiguration as Éµa} from './src/msal-angular.configuration';